<template>
  <span
    class="asahi-typography"
    :class="classObject"
  >
    <slot></slot>
  </span>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AsahiTypography',
  props: {
    type: {
      type: String,
      default: 'headline-big'
    },
    color: {
      type: String,
      default: 'primary-black'
    },
    font: {
      type: String,
      default: ''
    }
  },
  computed: {
    classObject () {
      return [this.type, this.color, this.font].join(' ')
    }
  }
})
</script>

<style scoped lang='scss'>
.asahi-typography {
  position: relative;
  font-family: $font-family;
  line-height: 24px;
}

.headline-main {
  font-size: calc($font-size * 2);
  font-weight: $font-weight-above-medium; /* 700 */
  @include media-breakpoint-up(xl) {
    font-size: calc($font-size * 3);
  }
}

.headline-big {
  // font-size: calc(16px * 2.5); /* 40px @ base 16px */
  font-size: calc($font-size * 1.75);
  font-weight: $font-weight-above-medium;
  @include media-breakpoint-up(xl) {
    font-size: calc($font-size * 2.5);
  }
}
.headline-bigger {
  @extend .headline-big;
}

.orange {
  color: $secondary-orange;
}
// .headline-small {
//   font-size: calc($font-size * 1);
//   font-weight: $font-weight-regular;
// }
// .headline-3 {
//   font-size: calc($font-size * 1);
//   font-weight: $font-weight-high; /* 800 */
// }

/**Headline XL */
.headline-regular {
  // font-size: calc(16px * 1.5); /* 24px @ base 16px */
  font-size: calc($font-size * 3.125);
  font-weight: $font-weight-regular; /* 300 */
}

.headline-bold {
  // font-size: calc(16px * 1.5); /* 24px @ base 16px */
  font-size: calc($font-size * 3.125);
  font-weight: $font-weight-medium; /* 500 */
}

.headline-extrabold {
  // font-size: calc(16px * 1.5); /* 24px @ base 16px */
  font-size: calc($font-size * 3.125);
  font-weight: $font-weight-above-medium; /* 700 */
}

/**Headline L */
.headline-1-regular {
  font-size: calc($font-size * 2.5); /* 36px @ base 16px */
  font-weight: $font-weight-regular; /* 700 */
  line-height: 48px;
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.5); /* 24px */
    line-height: 32px;
  }
}
.headline-1-bold {
  font-size: calc($font-size * 2.5); /* 36px @ base 16px */
  font-weight: $font-weight-medium; /* 700 */
  line-height: 48px;
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.5); /* 24px */
    line-height: 32px;
  }
}
.headline-1-extrabold {
  font-size: calc($font-size * 2.5); /* 36px @ base 16px */
  font-weight: $font-weight-above-medium; /* 700 */
  line-height: 48px;
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.5); /* 24px */
    line-height: 32px;
  }
}
.headline-1-high {
  font-size: calc($font-size * 2.5); /* 36px @ base 16px */
  font-weight: $font-weight-high; /* 900 */
  line-height: 48px;
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.5); /* 24px */
    line-height: 32px;
  }
}

/**Headline M */
.headline-2-regular {
  font-size: calc($font-size * 1.5); /* 24px @ base 16px */
  font-weight: $font-weight-regular; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.25); /* 20px */
  }
}
.headline-2-bold {
  font-size: calc($font-size * 1.5); /* 24px @ base 16px */
  font-weight: $font-weight-medium; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.25); /* 20px */
  }
}
.headline-2-extrabold {
  font-size: calc($font-size * 1.5); /* 24px @ base 16px */
  font-weight: $font-weight-above-medium; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.25); /* 20px */
  }
}
.headline-2-high {
  font-size: calc($font-size * 1.5); /* 24px @ base 16px */
  font-weight: $font-weight-high; /* 900 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * 1.25); /* 20px */
  }
}

/**Headline S */
.title-1-regular {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-regular; //300
}
.title-1-bold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-medium; //500
}
.title-1-extrabold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-above-medium; //700
}
.title-1-high {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-high; //900
}

/**Headline XS */
.title-2-regular {
  font-size: calc($font-size * 0.75); /* 12px @ base 16px */
  font-weight: $font-weight-regular; // 300
}
.title-2-bold {
  font-size: calc($font-size * 0.75); /* 12px @ base 16px */
  font-weight: $font-weight-medium; // 500
}
.title-2-extrabold {
  font-size: calc($font-size * 0.75); /* 12px @ base 16px */
  font-weight: $font-weight-above-medium; // 700
}
.title-2-high {
  font-size: calc($font-size * 0.75); /* 12px @ base 16px */
  font-weight: $font-weight-high; // 900
}

.title-3-regular {
  font-size: 16px;
  font-weight: 300;
}

/** DO NOT USE THESE CLASSES START */
.subtitle-light {
  font-size: calc($font-size * 1.125);/* 18px @ base 16px */
  font-weight: $font-weight-light; /* 300 */
}
.subtitle-regular {
  font-size: calc($font-size * 1.125);/* 18px @ base 16px */
  font-weight: $font-weight-regular; /* 400 */
}

.subtitle-bold {
  font-size: calc($font-size * 1.125); /* 18px @ base 16px */
  font-weight: $font-weight-medium; /* 600 */
}

.subtitle-extrabold {
  font-size: calc($font-size * 1.125); /* 18px @ base 16px */
  font-weight: $font-weight-above-medium; /* 700 */
}

.subtitle-high {
  font-size: calc($font-size * 1.125); /* 18px @ base 16px */
  font-weight: $font-weight-high; /* 800 */
}
/** DO NOT USE THESE CLASSES END */

/**CTA standard */
.subtitle-1-regular {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-regular; /* 300 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}

.subtitle-1-bold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-medium; /* 500 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.subtitle-1-extrabold {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-above-medium; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.subtitle-1-high {
  font-size: calc($font-size * 1); /* 16px @ base 16px */
  font-weight: $font-weight-high; /* 800 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.subtitle-1-line-through{
  text-decoration: line-through;
  font-size: calc($font-size * 1);
  font-weight: $font-weight-regular; /* 400 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}

/** Body XL*/
.body-1-regular {
  font-size: calc($font-size * 1.25); /* 20px @ base 16px */
  font-weight: $font-weight-regular; /* 300 */
}
.body-1-bold {
  font-size: calc($font-size * 1.25); /* 20px */
  font-weight: $font-weight-medium; /* 600 */
}
.body-1-extrabold {
  font-size: calc($font-size * 1.25); /* 20px */
  font-weight: $font-weight-above-medium; /* 700 */
}
.body-1-high {
  font-size: calc($font-size * 1.25); /* 20px */
  font-weight: $font-weight-high; /* 800 */
}

/**Body L */
.body-2-light {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-light; /* 100 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.body-2-regular {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-regular; /* 300 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.body-2-bold {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-medium; /* 500 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.body-2-extrabold {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-above-medium; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.body-2-high {
  font-size: calc($font-size * 1); /* 18px */
  font-weight: $font-weight-high; /* 900 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}

/** Body M */
.body-3-regular {
  font-size: calc($font-size * .875); /* 14px */
  font-weight: $font-weight-regular; /* 300 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .75); /* 12px */
    line-height: 16px;
  }
}
.body-3-bold {
  font-size: calc($font-size * .875); /* 14px */
  font-weight: $font-weight-medium; /* 500 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .75); /* 12px */
    line-height: 16px;
  }
}
.body-3-extrabold {
  font-size: calc($font-size * .875); /* 14px */
  font-weight: $font-weight-above-medium; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .75); /* 12px */
    line-height: 16px;
  }
}
.body-3-high {
  font-size: calc($font-size * .875); /* 14px */
  font-weight: $font-weight-high; /* 900 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .75); /* 12px */
    line-height: 16px;
  }
}

/**Body S */
.body-4-regular {
  font-size: calc($font-size * .75); /* 12px */
  font-weight: $font-weight-regular; /* 300 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .625); /* 10px */
    line-height: 16px;
  }
}
.body-4-bold {
  font-size: calc($font-size * .75); /* 12px */
  font-weight: $font-weight-medium; /* 500 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .625); /* 10px */
    line-height: 16px;
  }
}
.body-4-extrabold {
  font-size: calc($font-size * .75); /* 12px */
  font-weight: $font-weight-above-medium; /* 700 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .625); /* 10px */
    line-height: 16px;
  }
}
.body-4-high {
  font-size: calc($font-size * .75); /* 12px */
  font-weight: $font-weight-high; /* 900 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .625); /* 10px */
    line-height: 16px;
  }
}

/**Body XS */
.body-5-regular{
  font-size: $font-size-xxs; /* 10px @ base 16px */
  font-weight: $font-weight-regular;
}
.body-5-bold{
  font-size: $font-size-xxs; /* 10px @ base 16px */
  font-weight: $font-weight-medium;
}
.body-5-extrabold {
  font-size: $font-size-xxs; /* 10px @ base 16px */
  font-weight: $font-weight-above-medium;
}

.body-6-regular{
  font-size: $font-size-xxxs; /* 8px @ base 16px */
  font-weight: $font-weight-regular;
  line-height: 16px;
}

.button {
  // font-size: calc(16px * .5); /* 8px @ base 16px */
  line-height: 24px;
  font-size: calc($font-size * .875); /* 14px */
}
.caption {
  // font-size: calc(16px * .375); /* 6px @ base 16px */
  font-size: calc($font-size * .375);
}
.overline {
  // font-size: calc(16px * .25); /* 4px @ base 16px */
  font-size: calc($font-size * .5);
}

/** Textlink */
.text-link-extrabold {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-above-medium; /* 800 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}
.text-link-high {
  font-size: calc($font-size * 1); /* 16px */
  font-weight: $font-weight-high; /* 800 */
  @media (max-width: $breakpoint-md) {
    font-size: calc($font-size * .875); /* 14px */
  }
}

.headline-small-alt{
  font-size: calc($font-size * 1.25);
  font-weight: $font-weight-medium; /* 600 */
}

.product-bold-description {
  font-size: $font-size-sm; /* 16px @ base 16px */
  font-weight: $font-weight-medium; /* 600 */
}

.subtitle-grey-regular {
  font-size: $font-size-sm;
  color: $primary-dark-gray;
  font-weight: $font-weight-regular;
}

.subtitle-black-bold {
  font-size: $font-size-sm;
  color: $secondary-black;
  font-weight: $font-weight-medium;
}
</style>
